import React, { useCallback, useEffect, useState } from 'react';
import css from './styles.module.scss';
import { Typography, Switch, Paper, Box } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import { selectNewDeal, getDealTypeList } from '~/features/dashboard/store/selectors';
import { Controller, useForm } from 'react-hook-form';
import { StepControls } from '~/common/step-controls';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { createNewDealStepTwoThunk, getDealTypes } from '~/features/dashboard/store/actions.thunks';
import * as CreatorsListFeature from '~/features/creators-list';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { axiosInstance } from '~/api/config/axios.config';
import classNames from 'classnames';
import { orderBy } from 'lodash';
import { DealTypeList } from '~/models/deals/DealTypeList.dto';

interface Step_2Props {
    prevStep: () => void;
}

export const Step_2: React.FC<Step_2Props> = ({ prevStep }) => {
    const newDealState = useSelector(selectNewDeal);
    const dispatch = useThunkDispatch();
    const route = useAppRoute();
    let dealTypes = useSelector(getDealTypeList);
    let [dataoptions, setDataoptions] = useState<any>();
    let [showOption, setShowOption] = useState(false);

    const {
        handleSubmit,
        errors,
        formState: { isDirty },
        control,
        watch,
        setValue,
        register,
    } = useForm({
        defaultValues: {
            dealType: newDealState?.contractSubTypeList[0]?.accStatusUseId || 20,
            dealtypeOption: newDealState?.contractSubTypeList[0]?.accStatusExtUseId || 21,
            freeText: newDealState?.contractSubTypeList[0]?.freeText,
            acquisition: [],
        },
    });

    let watchContractType = watch('dealType');
    // let watchContractType = newDealState?.contractSubTypeList[0]?.accStatusUseId || 20;
    useEffect(() => {
        // TODO: use thunk
        axiosInstance.get('catalogue/ProjectCreator/dealSubtypeList').then(data => setDataoptions(data.data));
    }, []);

    let watchSubType = watch('dealtypeOption');
    let watchOtherSwitch = watch('57');

    const onSubmit = useCallback(
        data => {
            let contractNo = Number(data.dealType);
            let dealObj = dealTypes && dealTypes?.find((item: any) => item.id === Number(contractNo));
            let dealName = dealObj ? dealObj.name : 'PUBLISHING';
            if (!isDirty) {
                data.freeText = newDealState?.contractSubTypeList[0]?.freeText;
            }
            dispatch(createNewDealStepTwoThunk({ ...data, dealName, dealTypes, isDirty }));
        },
        [dispatch, isDirty, dealTypes] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(() => {
        dispatch(getDealTypes()).then(data => {
            if (data && data.error) {
                route(CreatorsListFeature.FEATURE_ROUTER_PATH);
            }
        });
    }, [dispatch, route]);

    useEffect(() => {
        if (newDealState?.contractType && dealTypes) {
            let name: string = newDealState?.contractType;
            let nameUpper: string = name.toUpperCase();
            dealTypes.map((item: any): any => {
                if (item.name === nameUpper) {
                    setValue('dealType', Number(item.id));
                }
                return item;
            });
        }
    }, [newDealState, dealTypes, setValue]);

    const userExists = (id: any) => {
        return newDealState?.contractSubTypeList?.some(function (el: any) {
            return String(el?.accStatusExtUseId) === String(id);
        });
    };

    let otherArray = [24, 38, 42, 63];

    useEffect(() => {
        if (watchSubType && newDealState) {
            if (otherArray.includes(Number(watchSubType))) {
                setShowOption(true);
            } else {
                setShowOption(false);
            }
        }
    }, [watchSubType]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (watchContractType === newDealState?.contractSubTypeList[0]?.accStatusUseId) return;

        switch (Number(watchContractType)) {
            case 20:
                setValue('dealtypeOption', 21);

                break;
            case 30:
                setValue('dealtypeOption', 31);

                break;
            case 40:
                setValue('dealtypeOption', 41);

                break;
            case 60:
                setValue('dealtypeOption', 61);

                break;

            default:
                break;
        }
    }, [watchContractType, newDealState]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (watchOtherSwitch) {
            setShowOption(true);
        } else {
            setShowOption(false);
        }
    }, [watchOtherSwitch]);

    useEffect(() => {
        if (newDealState) {
            // setValue('dealType');
            newDealState?.contractSubTypeList?.map((el: any) => {
                Number(el.accStatusExtUseId) === 57 && setShowOption(true);
            });
        }
    }, [newDealState]);

    // TODO: filter only once on load
    const orderSubTypes = (subType: DealTypeList[] = []) => {
        return orderBy(subType, [({ name }) => (name.toLowerCase() === 'other' ? 1 : 0), 'name'], ['asc']);
    };

    return (
        <Box className={css.module}>
            <Box className={css.wrapper}>
                <Paper square elevation={0} className={classNames(css.paper, css.header)}>
                    <Typography align={'left'} variant={'h5'}>
                        {newDealState?.contractTitle}
                    </Typography>
                </Paper>
                <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                    <input type="hidden" ref={register} name="dealType" defaultValue={watchContractType || 20} />
                    <div className={css.dealtypeSub}>
                        {Number(watchContractType) === 50 && (
                            <div style={{ display: Number(watchContractType) === 50 ? 'block' : 'none' }}>
                                <Typography align={'center'} variant={'h4'} className="songtitle lowersongtitle">
                                    What rights did the deal include:
                                </Typography>
                                {/* TODO: subsection must be unified as single component */}
                                <div className={css.switchsection}>
                                    {orderSubTypes(dataoptions?.acquisition).map((data: any) => (
                                        <div key={data.id} className={classNames(css.switchbox, 'inputcustom-outer')}>
                                            <div>
                                                <Typography align={'center'}>{data.name}</Typography>
                                            </div>
                                            <div>
                                                No
                                                <Controller
                                                    control={control}
                                                    name={`${data.id}`}
                                                    defaultValue={userExists(data.id) || false}
                                                    render={props => (
                                                        <Switch
                                                            type="checkbox"
                                                            name={`${data.id}`}
                                                            onChange={e => setValue(`${data.id}`, e.target.checked)}
                                                            value={props.value}
                                                            checked={props.value}
                                                        />
                                                    )}
                                                />
                                                Yes
                                            </div>
                                        </div>
                                    ))}
                                    <div>
                                        {showOption && (
                                            <Controller
                                                control={control}
                                                name={'freeText'}
                                                render={props => <TextField onChange={props.onChange} value={props.value} />}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        {Number(watchContractType) === 20 && (
                            <div>
                                <Typography align={'center'} variant={'h4'} className="songtitle lowersongtitle">
                                    What rights did the deal include:
                                </Typography>
                                <div>
                                    <Controller
                                        render={props => (
                                            <div className={css.publishingSection}>
                                                {orderSubTypes(dataoptions?.publishing).map((item: any) => (
                                                    <label key={item.id} className={css.keyReasonsCheckBox}>
                                                        <input
                                                            type="radio"
                                                            // ref={register({ required: true })}
                                                            value={String(item.id)}
                                                            checked={String(props.value) === String(item.id)}
                                                            name={'dealSubTypeOption'}
                                                            onChange={props.onChange}
                                                        />
                                                        <div className={classNames(css.optionSlab, String(props.value) === String(item.id) ? css.active : '')}>
                                                            <span>{item.name}</span>
                                                        </div>
                                                    </label>
                                                ))}

                                                <div>
                                                    {Number(watchSubType) === 24 && (
                                                        <Controller
                                                            control={control}
                                                            name={'freeText'}
                                                            render={props => <TextField onChange={props.onChange} value={props.value} />}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        name={'dealtypeOption'}
                                        control={control}
                                    />
                                </div>
                            </div>
                        )}
                        {Number(watchContractType) === 30 && (
                            <div>
                                <Typography align={'center'} variant={'h4'} className="songtitle lowersongtitle">
                                    What rights did the deal include:
                                </Typography>
                                <div>
                                    <Controller
                                        // defaultValue={Number(watchContractType) || 'ACQUISITION'}
                                        // defaultValue={watchSubType}
                                        render={props => (
                                            <div className={css.recordingSection}>
                                                {orderSubTypes(dataoptions?.recording).map((item: any) => (
                                                    <label key={item.id} className={css.keyReasonsCheckBox}>
                                                        <input
                                                            type="radio"
                                                            // ref={register({ required: true })}
                                                            value={String(item.id)}
                                                            checked={String(props.value) === String(item.id)}
                                                            name={'dealSubType'}
                                                            onChange={props.onChange}
                                                        />
                                                        <div className={classNames(css.optionSlab, String(props.value) === String(item.id) ? css.active : '')}>
                                                            <span>{item.name}</span>
                                                        </div>
                                                    </label>
                                                ))}

                                                <div>
                                                    {Number(watchSubType) === 38 && (
                                                        <Controller
                                                            control={control}
                                                            name={'freeText'}
                                                            render={props => <TextField onChange={props.onChange} value={props.value} />}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        name={'dealtypeOption'}
                                        control={control}
                                    />
                                </div>
                            </div>
                        )}
                        {Number(watchContractType) === 40 && (
                            <div>
                                <Typography align={'center'} variant={'h4'} className="songtitle lowersongtitle">
                                    What rights did the deal include:
                                </Typography>
                                <div>
                                    <Controller
                                        render={props => (
                                            <div className={css.publishingSection}>
                                                {orderSubTypes(dataoptions?.neighbouring).map((item: any) => (
                                                    <label key={item.id} className={css.keyReasonsCheckBox}>
                                                        <input
                                                            type="radio"
                                                            // ref={register({ required: true })}
                                                            value={String(item.id)}
                                                            checked={String(props.value) === String(item.id)}
                                                            name={'dealSubType'}
                                                            onChange={props.onChange}
                                                        />
                                                        <div className={classNames(css.optionSlab, String(props.value) === String(item.id) ? css.active : '')}>
                                                            <span>{item.name}</span>
                                                        </div>
                                                    </label>
                                                ))}

                                                <div>
                                                    {Number(watchSubType) === 42 && (
                                                        <Controller
                                                            control={control}
                                                            name={'freeText'}
                                                            render={props => <TextField onChange={props.onChange} value={props.value} />}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        name={'dealtypeOption'}
                                        control={control}
                                    />
                                </div>
                            </div>
                        )}
                        {Number(watchContractType) === 60 && (
                            <div>
                                <Typography align={'center'} variant={'h4'} className="songtitle lowersongtitle">
                                    What rights did the deal include:
                                </Typography>
                                <div>
                                    <Controller
                                        render={props => (
                                            <div className={css.publishingSection}>
                                                {orderSubTypes(dataoptions?.Other).map((item: any) => (
                                                    <label key={item.id} className={css.keyReasonsCheckBox}>
                                                        <input
                                                            type="radio"
                                                            // ref={register({ required: true })}
                                                            value={String(item.id)}
                                                            checked={String(props.value) === String(item.id)}
                                                            name={'dealSubType'}
                                                            onChange={props.onChange}
                                                        />
                                                        <div className={classNames(css.optionSlab, String(props.value) === String(item.id) ? css.active : '')}>
                                                            <span>{item.name}</span>
                                                        </div>
                                                    </label>
                                                ))}

                                                <div>
                                                    {Number(watchSubType) === 63 && (
                                                        <Controller
                                                            control={control}
                                                            name={'freeText'}
                                                            render={props => <TextField onChange={props.onChange} value={props.value} />}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        name={'dealtypeOption'}
                                        control={control}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <StepControls onPrevClick={prevStep} errors={errors} />
                </form>
            </Box>
        </Box>
    );
};
